import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { QuoteData } from "../types";

export type QuoteStatsData = Pick<QuoteData, "id_quote" | "status_quote">;

export const fetchQuotesStats = async (): Promise<ApiResponse<QuoteStatsData[]>> => {
  return await apiClient<ApiResponse<QuoteStatsData[]>>('/v1/quotes/stats');
};
